import type { ReactNode } from 'react'
import { use, useEffect } from 'react'
import { OverlayFooterContext } from '../components/Overlay/OverlayContext'

/**
 * Injects footer content into the nearest <Overlay> DrawerFooter.
 * Wrap the JSX in useMemo so it only re-registers when real deps change.
 *
 * @example
 * const footer = useMemo(() => <Button onClick={submit}>Save</Button>, [submit])
 * useOverlayFooter(footer)
 */
export const useOverlayFooter = (footer: ReactNode) => {
  const setFooter = use(OverlayFooterContext)

  useEffect(() => {
    setFooter?.(footer)
    return () => setFooter?.(null)
  }, [footer, setFooter])
}
